import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'any'
})
export class UserProfileService {
  private http = inject(HttpClient);


  private BASE_URL = environment.RH_BASE_URL;

  updateProfile(_id: string, name: string, phone: string): Observable<HttpResponse<any>> {
    return this.http.patch<HttpResponse<any>>(`${this.BASE_URL}/mgmt/users/${_id}`, {name, phone}, {
      responseType: 'json',
      observe: 'response'
    })
  }

}
